import { Fragment, useState } from "react";
import Config from "../../../Config";
import InputComboRok from "../../../helpers/InputComboRok";
import InputComboMiesiac from "../../../helpers/InputComboMiesiac";
import InputLegend from "../../../helpers/InputLegend";


 
function AllHour(props)
{

    var dt = new Date();

    var strM = (dt.getMonth()+1)+"";
    if(strM.length == 1) strM = "0" + strM;
 
    var strD = dt.getDate()+"";
    if(strD.length == 1) strD = "0" + strD;
 
    //var dateX  = dt.getFullYear()+"-"+strM+"-"+strD;


    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({   
                 
 
        rok: dt.getFullYear(),
        miesiac: strM,
 
        limit: 50,
        page: 1,
        pages: 1,
    });



    
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState(null);


    const getData = () => {


        props.mainView.setProgress(-2);
 

        fetch( Config.url + '/rest_v1_parents,all_hour', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);                                                                                         
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
               



    }





    
    const valChangeListenerFilter = (filedName, val, correct, msg) => {

       
        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );       
        setTab(null);
    }


    const filterApprove = () => {   
        setTab(null)     
    }


    const filterClear = () => {
        setFilterParam({     
            rok: (new Date()).getFullYear() ,
            miesiac: (new Date() ).getMonth()+1,            
            sortBy: {
                sort:  "", //asc desc,
                column: "",
            },
        });
        setTab(null);
 
    }

    const goNextNew = () => {
      
    }


    const [legend, setLegend] = useState([
        {
            cls:'color_show_nb_w_czasie',
            title: 'Wejście ',
       
        },
        {
            cls:'color_show_nb_po_czasie',
            title: 'Wyjście',
       
        },
    ]);




    
    if(tab == null)
        {
            setTab([]);
            getData();      
            return (
                <div></div>
            );        
        }


    
    if(refreshView != props.userData.refreshView)
    {         
          setRefreshView( props.userData.refreshView);
          setTab(null);
    }    







    return <div>

            

                        <div className="table_filter">

                                <div className="filter_controll">   
                                        <label>Rok: </label>                             
                                        <InputComboRok   userData={props.userData}  mainView={props.mainView}  value={filterParam.rok}   valChange={valChangeListenerFilter} goNext={goNextNew} name="rok" placeholder={": "}  noempty="1"   />
                                </div> 

                                <div className="filter_controll">   
                                        <label>Miesiąc: </label>                             
                                        <InputComboMiesiac   userData={props.userData}  mainView={props.mainView}  value={filterParam.miesiac}   valChange={valChangeListenerFilter} goNext={goNextNew} name="miesiac" placeholder={": "}  noempty="1"   />
                                </div>


                                <div className="filter_btn">                                                     
                                            <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                                </div>

                        </div>


                        <div className="table_widget">
                            <div>
                                * Godziny do rozliczenia - faktyczna ilość godziny pomniejszona o czas bezpłatny.
                            </div>
                            <br/>
                            <div>
                                ** Nadgodziny - czas pobytu dziecka w placówce wykracząjący poza deklarowany czas pobytu zawarty w umowie.  
                            </div>
                            <br/>
                            <InputLegend items={legend} />                                         
                        </div>


                        <div className="bg_center">
                          

                                    <div className="scorll_x">

                                          
                                                <table className="table"  >
                                                    <thead>
                                                                <tr className="header">
                                                                    <td className="td_left gocenter">LP</td>
                                                                    <td className="gocenter">Dzień</td>                                                                                      
                                                                    <td>Odnotowane wejścia i wyjścia</td>                                                                                                                                       
                                                                    <td>Godziny pobytu (faktycznie)</td>
                                                                    <td>Godziny do rozliczenia*</td>
                                                                    <td className="td_right">**Nadgodziny</td> 
                                                                    <td className="td_option"> </td>                                                   
                                                                </tr>
                                                    </thead>

                                                    <tbody>
                                                        {
                                                            tab.map( (item, ix) => {

                                                                 return <tr>

                                                                    <td className="gocenter">{ix+1}</td>
                                                                    <td className="gocenter min_width100px">{item.ymd}</td>                                                                                      
                                                                    <td>
                                                                        {
                                                                            item.inout.length == 0 &&
                                                                            <span>brak zarejestrowanego wejścia i wyjścia</span>
                                                                        }

                                                                        {
                                                                            item.inout.map( (io, inxIO) => {

                                                                                if(io.operacja == "I")
                                                                                {
                                                                                    return <div>
                                                                                        <span className="color_show_nb_w_czasie">&nbsp;</span> {io.godzina}&nbsp;&nbsp;&nbsp;
                                                                                    </div>
                                                                                }
                                                                                    
                                                                                if(io.operacja == "O")
                                                                                    {
                                                                                        return <div>
                                                                                        <span className="color_show_nb_po_czasie">&nbsp;</span> {io.godzina}&nbsp;&nbsp;&nbsp;
                                                                                    </div>
                                                                                    }

                                                                            } )
                                                                        }
                                                                    </td>                                                                                                                                       
                                                                    <td className="gocenter">
                                                                        {item.hour.ilosc_minut_Hm}
                                                                    </td>

                                                                    <td className="gocenter">
                                                                       
                                                                        {   
                                                                            item.hour.korekta_min_platne  < 0 &&
                                                                            <span>{item.hour.obliczone_min_platne_Hm}</span>
                                                                        }

                                                                        {
                                                                            item.hour.korekta_min_platne > 0 &&
                                                                            <span>{item.hour.korekta_min_platne_Hm}</span>
                                                                        }


                                                                    </td>

                                                                    <td className="gocenter">
                                                                        {item.over.ilosc_minut_Hm}
                                                                    </td>                                                                 

                                                                 </tr>
                                                            } )
                                                        }
                                                    </tbody>

                                                </table>  

                                    </div>

                        </div>
 
    </div>
}


export default AllHour;